export var defaultFontStyle = {
    fontFamily: "root"
};
